import { Injectable, Output, EventEmitter } from '@angular/core';
import { of, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MenuService {
  @Output() getItemFromMenu: EventEmitter<any> = new EventEmitter();
  @Output() getItemGroupData: EventEmitter<any> = new EventEmitter();

  getNavItem(itemName: any): Observable<any> {
    if (itemName) {
      this.getItemFromMenu.emit(itemName);
      return of(itemName);
    } else {
      this.getItemFromMenu.emit(0);
      return of(0);
    }
  }
  
}


